<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <tr v-for="(row, index) in filtered_patient" :key="index">
                            <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                            <td>{{row | arrayValuesFormatter }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      patient: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    data() {
      return {
        excludeFields: ['id']
      }
    },
    computed: {
      filtered_patient() {
        return this.excluder(this.patient, this.excludeFields);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/Tabs/PatientTab.vue